import React from 'react';
import {Select, Icon} from '@shopify/polaris';
import webhookStructure from '../data/webhook.json';
import styled from 'styled-components';

const capitalize = (string) => string[0].toUpperCase() + string.substring(1);

const Row = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	
	> :not(.right-side) {
		display: inline-block;
		// width: 60% !important;	
	}
	
	.rightSide {
		// width: 40%;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}
	
	.icon {
		margin: 0 1rem;
	}
`;

const label = (rawLabel) => {
	return `._${rawLabel}_.`
		.split('_')
		.join(' ')
		.split('.')
		.slice(1)
		.join(' ')
		.split(' ')
		.filter(Boolean)
		.map(capitalize)
		.join(' ');
};

export default class WebhookPropertySelector extends React.Component {
	handleChange = (newValue) => {
		this.props.onChange(this.props.tagName, newValue);
	};

	renderOptions = (property) => {
		if (typeof property === 'object') {
			return {
				title: property.key,
				options: property.properties.map(key => `${property.key}.${key}`).map(this.renderOptions)
			};
		}

		return {
			label: label(property),
			value: property
		};
	};

	render() {
		return (
			<Row>
                <Select
                    onChange={this.handleChange}
                    placeholder="Please select"
                    options={webhookStructure.map(this.renderOptions).filter(Boolean)}
                    value={this.props.value}
                    label={this.props.tagName}
					labelHidden={true}
                />
				<span className={'rightSide'}>
					<span className={'icon'}><Icon source={'arrowRight'}/></span>
					<span>{this.props.tagName}</span>
				</span>
			</Row>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/webhook-property-selector.js